<template>
    <div class="listing-card">
      <a :href="item.href" @click="disable(item, $event)" :class="{disabled: item.minilist}" data-cy="listing-item" :data-cy-showing="(item.hasShowing && !item.sold ? '1' : '0')">
        <div class="position-relative listing-card-image-wrapper">

          <span class="image-overlay">
            <picture v-if="columns === 2 || columns === '2'">
              <source media="(min-width:576px)" :srcset="item.img.src">
                <img :src="item.img.mobile_src">
            </picture>
          </span>

          <span class="image-overlay">
            <picture v-if="columns === '1'">
              <source media="(min-width:576px)" :srcset="item.img.src_large">
                <img :src="item.img.mobile_src">
            </picture>
          </span>

          <span v-if="badgesData">
            <span class="status-badge">
              <span class="status-badge-text fs-18">{{ badgesData }}</span>
            </span>
          </span>
          <div class="listing-card-content position-absolute d-flex flex-wrap justify-content-center align-content-end text-center color-white pb-1">
            <h2 class="w-100 mb-0_5" v-if="!item.newproduction">{{ item.descriptionType }}</h2>
            <h2 class="w-100 mb-0_5" v-if="item.newproduction && item.newproductionTitle">{{ item.newproductionTitle }}</h2>
            <h2 class="w-100 mb-2">{{ item.commune }} <span v-if="!item.newproduction && item.commune !== item.district"><span v-if="item.district">-</span> {{ item.district }}</span></h2>
            <p class="d-flex flex-wrap mb-0_5 fs-18-normal">
            <span v-if="item.metaString.length > 0 && !['Tomt', 'Kommersiell fastighet'].includes(item.descriptionType)" v-for="(meta, index) in item.metaString">
              {{ meta }}<span v-if="index !== (item.metaString.length - 1)" class="mr-0_5">,</span>
            </span>
              <span v-if="item.descriptionType === 'Tomt' && item.lotarea > 0">{{ item.lotarea }} kvm</span>
              <span v-if="item.descriptionType === 'Kommersiell fastighet' && item.commercialarea > 0">{{ item.commercialarea }} kvm</span>
              <span v-if="item.newproduction && item.salesTitle">{{ item.salesTitle }}</span>
            </p>
          </div>
        </div>
      </a>
    </div>
</template>
<script>
export default {
  data: function() {
    return {
      badges: [],
    };
  },
  methods: {
    disable(item, $event) {
      if (item.minilist) {
        $event.preventDefault();
      }
    }
  },
  computed: {
    badgesData() {
      this.badgeText = '';
      if (this.item.hasBiddings && !this.item.sold) {
        this.badgeText = 'Budgivning pågår';
      }

      if (this.item.hasShowing && !this.item.sold) {
        this.badgeText = 'Visning';
      }

      if (this.item.upcoming && !this.item.sold) {
        this.badgeText = 'Kommande';
      }

      if (this.item.newproduction && !this.item.sold) {
        this.badgeText = 'Nyproduktion';
      }

      if (this.item.newproductionobj && !this.item.sold) {
        this.badgeText = 'Nyproduktion';
      }

      if (this.item.sold && !this.item.newproduction) {
        this.badgeText = 'Såld';
      }

      if (this.item.sold && this.item.newproduction) {
        this.badgeText = 'Slutsålt';
      }
      return this.badgeText;
    }
  },
  props: [
    'item',
    'columns'
  ],
};
</script>
<style scoped>

.listing-card-content {
  border: 1px solid rgba(255, 255, 255, 0.6);
  top: 17px;
  bottom: 17px;
  right: 17px;
  left: 17px;
  z-index: 1;
}

.listing-card-image-wrapper::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 50%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%);
}

.disabled {
  cursor: default;
}
</style>
